export default {
  parallaxAnimation(e) {
    let w = window.innerWidth / 1;
    let h = window.innerHeight / 1;
    let mouseX = e.clientX;
    let mouseY = e.clientY;
    let vidX = `${(mouseX-w)*0.005}%`
    let vidY = `${(mouseY-h)*0.005}%`

    return {vidX , vidY}

    // elem.style.top = vidY;
    // elem.style.left = vidX;
  }
}